import { css } from '@eti/styles';
import { rowItemSize } from '../../utils/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const columnDetailStyles = css`
  align-items: center;
  display: flex;
  font-size: 0.75rem;
  justify-content: center;
  ${rowItemSize};
`;
const ColumnDetail = _ref => {
  let {
    columnName
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: columnDetailStyles,
    children: columnName
  });
};
export default ColumnDetail;
//# sourceMappingURL=ColumnDetail.js.map